module.exports = __webpack_public_path__ + "img/stiftung_leistungssport.0f818265.png";